<template>
  <el-dialog class="media-manager" title="Choose an image" :visible.sync="open" :before-close="sendClose" :append-to-body="true" width="700px">
    <div class="filters">
      <span v-for="library in libraries" :key="library.id" @click="librarySelected = library" :class="{ selected: library == librarySelected }">{{ library.name[lang] }}</span>
    </div>
    <div class="medias">
      <ul class="content__list">
        <li>
          <el-upload class="upload-buttons"
                     v-if="librarySelected && librarySelected.idSite"
                     :http-request="addAttachment"
                     :action="url"
                     :show-file-list="false">
            <el-button class="upload-button" plain>
              <font-awesome-icon icon="file-upload" />
            </el-button>
          </el-upload>
        </li>
        <li v-for="media in filteredMedias" :key="media.id" @click="select(media)" :class="{ selected: isSelected(media) }">
          <image-loader height="80px" width="80px" :src="media.url" />
        </li>
      </ul>
    </div>
  </el-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  props: ['img', 'open'],
  data () {
    return {
      selected: null,
      librarySelected: null
    }
  },
  computed: {
    ...mapGetters('libraries', {
      libraries: 'libraries'
    }),
    ...mapGetters('medias', {
      medias: 'medias'
    }),

    ...mapGetters('account', {
      site: 'currentSite',
      lang: 'defaultLang'
    }),

    filteredMedias () {
      return this.medias.filter(media => {
        return (this.librarySelected && media.idlibrary === this.librarySelected.id ? media : null)
      })
    },
    url () {
      return process.env.API + '/library/' + this.librarySelected.id + '/media/'
    }
  },
  methods: {
    ...mapActions('libraries', ['addLibrary', 'removeLibrary', 'loadLibraries']),
    ...mapActions('medias', ['loadMedias', 'addMedia']),

    initLibrariesList () {
      if (this.site) {
        this.loadLibraries(this.site.sitekey)
          .then((libraries) => {
            if (libraries.length > 0) {
              this.librarySelected = libraries[0]
            }

            let promises = []
            libraries.forEach((library) => {
              promises.push(this.loadMedias(library))
            })

            return Promise.all(promises)
          })
      }
    },

    select (media) {
      this.selected = media
      this.$emit('selected', media)
    },
    sendClose () {
      this.$emit('close')
    },
    isSelected (media) {
      if (this.selected) {
        if (this.selected.id === media.id) {
          return true
        }
      }
      return false
    },
    addAttachment (uploader) {
      this.addMedia({libraryId: this.librarySelected.id, media: uploader.file}).then((media) => {
      })
    }
  },

  watch: {
    site: function (site) {
      this.initLibrariesList()
    }
  },
  mounted () {
    this.initLibrariesList()
  }
}
</script>

<style lang="scss" scoped>
  .media-manager {
    background: #fff;
    border-radius: 4px;

    .filters {
      padding: 0 0 8px 0;
      span {
        display: inline-block;
        padding: 4px 8px;
        border-radius: 4px;
        border:1px solid #dedede;
        margin: 4px;
        font-weight: 600;
        cursor: pointer;
        &.selected {
          background: #dedede;
        }
      }
    }
    .medias {
      ul {
        max-height: 400px;
        overflow-y: auto;
        li {
          list-style: none;
          display: inline-block;
          margin: 4px;
          cursor: pointer;
          border: 8px solid #fff;
          border-radius: 4px;
          img {
            height: 80px;
            border-radius: 4px;
            display: block;
          }
          &:hover {
            border-color: #dedede
          }
        }
      }
    }

    .upload-buttons {
      display: inline;
      > div {
        width: 80px;
        height: 80px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/libraries/library-manager.vue